import * as yup from 'yup'

{
  /* ひとまず英語にした sakao  */
}
export const MfaSchema = yup
  .string()
  .matches(/^[\d]+$/, 'number_warning')
  .min(6, 'number_warning')
  .max(6, 'number_warning')
  .required('passward_warning')

// import * as yup from "yup";
// export const anonymousLoginSchema = yup.object().shape({
//   /* ひとまず英語にした sakao  */
//   password: yup
//     .string()
//     .matches(/^[\d]+$/, "Please enter 6 digits")

//     .min(6, "Please enter 6 digits")
//     .max(6, "Please enter 6 digits")
//     .required("Please enter your password"),
// });
